export default {
  init: require('./init').default,
  start: require('./start').default,
  set: require('./set').default,
  finish: require('./finish').default,
  cancel: require('./cancel').default,
  submit: require('./submit').default,
};
